import {getCurrentUserLogin} from '@github-ui/client-env'
import {CommentIcon} from '@primer/octicons-react'
import type {IssueComment} from '../../../../../page-data/payloads/issue-comments'
import {useLayoutAuthorLogin} from '../../../../../stores/layout-selectors'
import {IssueCommentItem} from '../../../../toolbar/IssueCommentItem'
import {ForYouItem} from '../../shared/ForYouItem'
import {ForYouLeadingIcon} from '../../shared/ForYouLeadingIcon'
import {CommentIdentity} from '../shared/CommentIdentity'
import {CompactComment} from '../shared/CompactComment'
import {CompactContainer} from '../shared/CompactContainer'
import {getIssueCommentAuthor} from '../util/comment-identity'
import {RelativeTime} from '@primer/react'
import styles from './ForYouIssueComment.module.css'

export function ForYouIssueCommentItem({comment}: {comment: IssueComment}) {
  const pullRequestAuthorLogin = useLayoutAuthorLogin()

  return (
    <ForYouItem
      key={comment.id}
      title={<IssueCommentTitle comment={comment} />}
      ariaLabel={`${comment.authorLogin} commented`}
      itemName="issue-comment"
      leadingVisual={<ForYouLeadingIcon icon={CommentIcon} />}
      description={
        <CompactContainer>
          <CompactComment
            body={comment.body}
            isPending={false}
            author={{login: comment.authorLogin, avatarUrl: comment.authorAvatarUrl}}
          />
        </CompactContainer>
      }
      padding="none"
    >
      <IssueCommentItem
        comment={comment}
        pullRequestAuthorLogin={pullRequestAuthorLogin}
        canReact
        className="border-0"
      />
    </ForYouItem>
  )
}

function IssueCommentTitle({comment}: {comment: IssueComment}) {
  const author = getIssueCommentAuthor(comment.authorLogin, getCurrentUserLogin())

  return (
    <span>
      <CommentIdentity login={author.login} linkable={author.linkable} /> commented{' '}
      <RelativeTime datetime={comment.createdAt} className={styles.timestamp} />
    </span>
  )
}
